import React from "react";
import { skillsData } from "../../data";

export default function Skills() {
  return (
    <div className="md:py-20 py-10">
      <div className="container px-4 mx-auto">
        <div className="text-center">
          <h2 className="headline text-neutral-900 dark:text-neutral-100 mb-10">
            I Can Code With
          </h2>
        </div>
        <div className="flex flex-wrap gap-4 justify-center">
          {skillsData.map((item) => (
            <div
              key={item.id}
              className="w-36 h-36 flex flex-col justify-between items-center bg-neutral-100 dark:bg-neutral-800 overflow-hidden text-center rounded-lg p-4"
            >
              <img
                className="w-20 h-w-20 mx-auto rounded-xl"
                src={item.img}
                alt="img"
              />
              <h4 className="text-neutral-900 dark:text-neutral-100 font-semibold ">
                {item.title}
              </h4>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
